import request from '@/utils/request'

// 产业园每日计划分析报表
export function apiGetInvDailyPlanAnalysisList (query) {
	return request({
		url: `/inv/invDailyPlanAnalysis/list`,
		method: 'get',
		params: query
	})
}

// 导出列表
export function apiInvDailyPlanAnalysisExport (data) {
  return request({
    url: '/inv/invDailyPlanAnalysis/export',
    method: 'post',
    data: data
  })
}

// 查询实际完成明细
export function apiSearchRealCompletedDetail (data) {
  return request({
    url: `/inv/invDailyPlanAnalysis/searchRealCompletedDetail`,
    method: 'post',
    data: data
  })
}
